import styled from 'styled-components';
import Modal from 'components/_UI/Modal';
import Text from 'components/_UI/Text';
import Button from 'components/_UI/Button';
import Loader from 'components/_UI/Loader';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import buttonText from 'texts/buttons/buttonText';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';

/* As duas ações irreversíveis do formulário bancário — descartar o que foi
   digitado e excluir a conta — pedem a mesma pergunta em telas diferentes.
   Fica aqui para as duas terem exatamente o mesmo peso visual. */
export default function ConfirmDialog({
    visible,
    title,
    description,
    confirmLabel,
    cancelLabel,
    loading,
    error,
    onConfirm,
    onCancel,
}) {
    return (
        <Modal isOpen={visible} onClose={onCancel}>
            <Text name='highlight'>
                {title}
            </Text>

            <Text name='default' marginTop='10px'>
                {description}
            </Text>

            {loading ? (
                <FullyCentered height='40px'>
                    <Loader />
                </FullyCentered>
            ) : (
                <ButtonsContainer>
                    <Button
                        variant='light'
                        category='roundedBorded'
                        onClick={onCancel}
                    >
                        {cancelLabel || buttonText.cancel}
                    </Button>

                    <Button
                        variant='danger'
                        category='roundedBorded'
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </Button>
                </ButtonsContainer>
            )}

            {error && (
                <Text color={colors.danger} name='small' marginTop='10px'>
                    {error}
                </Text>
            )}
        </Modal>
    )
}

const ButtonsContainer = styled(Column)`
    margin-top: 20px;

    @media screen and (min-width: ${breakpoints.md}) {
        flex-direction: row;

        button:nth-child(2) {
            margin-left: 10px;
        }
    }
`;
